<button [routerLink]="url">{{ buttonText }}</button>
